var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Env } from "core/utils";
import * as Option from "fp-ts/lib/Option";
import { CondencedHighlight } from "pages/home/components/CondensedHighlight";
import { PromotedHighlight } from "pages/home/components/PromotedHighlight";
import React from "react";
import styled from "styled-components";
function isCompatible(homepage) {
    return (homepage.highlightedPrograms !== null &&
        homepage.highlightedPrograms.length > 0 &&
        Env.isClient);
}
export var block = function (position) {
    return function (data) {
        var _a, _b, _c, _d;
        if (!isCompatible(data))
            return Option.none;
        var filteredItems;
        if (position === 1) {
            filteredItems = (_a = data === null || data === void 0 ? void 0 : data.highlightedPrograms) === null || _a === void 0 ? void 0 : _a.filter(function (item, index) { return index === 0; });
        }
        else if (position === 2) {
            filteredItems = (_b = data === null || data === void 0 ? void 0 : data.highlightedPrograms) === null || _b === void 0 ? void 0 : _b.filter(function (item, index) { return 4 > index && index > 0; });
        }
        else {
            filteredItems = (_c = data === null || data === void 0 ? void 0 : data.highlightedPrograms) === null || _c === void 0 ? void 0 : _c.filter(function (item, index) { return 4 <= index; });
        }
        var promotedItems = (_d = data === null || data === void 0 ? void 0 : data.highlightedPrograms) === null || _d === void 0 ? void 0 : _d.filter(function (item) { return item.highLightType === "Promoted"; });
        var getDirection = function (item) {
            var index = promotedItems.findIndex(function (promoted) { return promoted === item; });
            return (index & 1) === 0 ? "right" : "left";
        };
        return Option.some({
            key: "highlightedPrograms " + position,
            View: function () { return (React.createElement(Container, null, filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.map(function (item, index) {
                return item.items.length > 0 &&
                    (item.highLightType === "Promoted" ? (React.createElement(PromotedHighlight, { program: item.program, highlights: item.items, direction: getDirection(item), key: index })) : (React.createElement(CondencedHighlight, { program: item.program, highlights: item.items, key: index })));
            }))); },
        });
    };
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 2rem;\n  gap: 3rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 2rem;\n  gap: 3rem;\n"])));
var templateObject_1;
